<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="tx-ni ParaOverride-1"><span epub:type="pagebreak" id="pageix" title="ix"></span></p>
<p class="tx-ni ParaOverride-3" id="_idParaDest-4">For my great-nephew Harry James Estep, who entered this world at 6:31 p.m. on the evening of June 15, 2018. </p>
<p class="tx-ni ParaOverride-2">—<span class="CharOverride-2">Richard Estep</span></p>
<p class="tx-ni ParaOverride-3">In memory of the victims. May they rest in peace. </p>
<p class="tx-ni ParaOverride-2">—<span class="CharOverride-2">Robert Graves</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?69692f13